import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cx } from '../cx';
import styles from './Choice.module.css';

// Radio — DESIGN_SYSTEM §12 row 5. Native <input type="radio"> in its <label>; siblings share a `name` and
// the browser gives them the arrow-key group behaviour for free.

export interface RadioProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  name: string;
  value: string;
  testID?: string;
  /** The visible label text — also the accessible name. */
  children: ReactNode;
  className?: string;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { testID, children, className, disabled, ...rest },
  ref,
) {
  return (
    <label className={cx(styles.choice, disabled && styles.disabled, className)}>
      <input
        ref={ref}
        type="radio"
        className={cx(styles.control, styles.radio)}
        disabled={disabled}
        data-testid={testID}
        {...rest}
      />
      {children}
    </label>
  );
});
